/* app/js/src/components/mam-explorer/mam-explorer-container/mam-explorer-container.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.mam-explorer {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
}
.mam-explorer__header {
  padding: 16px 24px 0;
}
.mam-explorer__title {
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  color: rgb(35, 47, 58);
  margin: 0;
}
.mam-explorer__grid-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0 24px 16px;
}
.mam-explorer__grid-container ag-grid-angular {
  flex: 1;
  width: 100%;
}
.mam-explorer__bulk-btn {
  cursor: pointer;
  display: flex;
  padding: 9px 16px 9px 9px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.54);
  background: transparent;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
.mam-explorer__bulk-btn svg {
  fill: currentColor;
}
.mam-explorer .button-disabled {
  cursor: not-allowed;
  background: rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
:host ::ng-deep .ag-theme-evrideo .ag-header-cell:not(.mam-explorer__checkbox-header-cell) {
  padding-top: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}
:host ::ng-deep .ag-theme-evrideo .ag-header-cell:not(.mam-explorer__checkbox-header-cell) .ag-cell-label-container {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
:host ::ng-deep .ag-theme-evrideo .ag-header-cell:not(.mam-explorer__checkbox-header-cell) .ag-header-cell-comp-wrapper,
:host ::ng-deep .ag-theme-evrideo .ag-header-cell:not(.mam-explorer__checkbox-header-cell) .ag-header-cell-label {
  margin-left: 0 !important;
  padding-left: 0 !important;
}
:host ::ng-deep .ag-theme-evrideo .ag-cell:not(.mam-explorer__checkbox-cell) {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
:host ::ng-deep .ag-theme-evrideo .mam-explorer__checkbox-cell {
  padding: 0 !important;
}
:host ::ng-deep .ag-theme-evrideo .mam-explorer__checkbox-header-cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
:host ::ng-deep .ag-theme-evrideo .mam-explorer__checkbox-header-cell .ag-header-cell-comp-wrapper {
  width: 100%;
  justify-content: center;
}
:host ::ng-deep .ag-theme-evrideo .mam-explorer__name-cell {
  overflow: hidden;
}
:host ::ng-deep .ag-theme-evrideo .mam-explorer__video-id-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .ag-body-vertical-scroll {
  max-width: 12px !important;
  width: 12px !important;
  min-width: 12px !important;
  opacity: 1 !important;
}
::ng-deep .ag-body-vertical-scroll-viewport {
  width: 12px !important;
}
::ng-deep .ag-body-vertical-scroll-container {
  min-width: 12px !important;
}
/*# sourceMappingURL=mam-explorer-container.component.css.map */
